import './loading.css';

const Loading = ({ ...props }) => (
  <svg {...props} width="40" height="40" viewBox="0 0 40 40">
    <polygon points="0 0 0 40 40 40 40 0" className="widget loading" />
  </svg>
);
export default Loading;
